import React, { Component } from 'react';
import styled from '@emotion/styled';
// import polina from './images/polina.jpg'
const Wrapper = styled.div`
    video { 
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -100;
    transform: translateX(-50%) translateY(-50%);
     background: url('https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=847&q=80') no-repeat;
     background-size: cover;
    transition: 1s opacity;
}
.stopfade { 
   opacity: .5;
}

#polina { 
  font-family: Agenda-Light, Agenda Light, Agenda, Arial Narrow, sans-serif;
  font-weight:100; 
  background: rgba(0,0,0,0.3);
  color: white;
  padding: 2rem;
  width: 33%;
  margin:2rem;
  float: right;
  font-size: 1.2rem;
}
h1 {
  font-size: 3rem;
  text-transform: uppercase;
  margin-top: 0;
  letter-spacing: .3rem;
}
#polina button { 
  display: block;
  width: 80%;
  padding: .4rem;
  border: none; 
  margin: 1rem auto; 
  font-size: 1.3rem;
  background: rgba(255,255,255,0.23);
  color: #fff;
  border-radius: 3px; 
  cursor: pointer;
  transition: .3s background;
}
#polina button:hover { 
   background: rgba(0,0,0,0.5);
}

a {
  display: inline-block;
  color: #fff;
  text-decoration: none;
  background:rgba(0,0,0,0.5);
  padding: .5rem;
  transition: .6s background; 
}
a:hover{
  background:rgba(0,0,0,0.9);
}
/* @media screen and (max-device-width: 375px) {
  html { background: url(polina) #000 no-repeat center center fixed; }
  #bgvid { display: none; }
}

@media screen and (max-width: 500px) { 
  div{width:70%;} 
}
@media screen and (max-device-width: 800px) {
  html { background: url(polina) #000 no-repeat center center fixed; }
  #bgvid { display: none; }
} */
`


class VideoComponent extends Component {
    render() {
        return (
            <React.Fragment>
                <Wrapper>
                    <video poster={"https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=847&q=80"} id="bgvid" playsInline autoPlay muted loop>
                        {/* <source src="http://thenewcode.com/assets/videos/polina.webm" type="video/webm" />
                        <source src="http://thenewcode.com/assets/videos/polina.mp4" type="video/mp4" /> */}
                        <source src="https://cs6.rbmbtnx.net/v1/RBTV/pd/1/ZC/BF/S2/U1/5N/11/FO-1ZCBFS2U15N11.mp4" type="video/mp4" />
                        <source src="https://cs6.rbmbtnx.net/v1/RBTV/pd/1/ZC/BF/S2/U1/5N/11/FO-1ZCBFS2U15N11.mp4" type="video/mp4" />
                    </video>
                </Wrapper>
            </React.Fragment>
        );
    }
}

export default VideoComponent;